import React from 'react';
import { StarIcon, CheckCircleIcon } from 'lucide-react';
export const Reviews = () => {
  // Helper function to render stars based on rating
  const renderStars = rating => {
    const stars = [];
    for (let i = 0; i < 5; i++) {
      stars.push(<StarIcon key={i} className={`w-5 h-5 ${i < rating ? 'text-green-500 fill-green-500' : 'text-gray-200'}`} data-id="element-182" />);
    }
    return <div className="flex" data-id="element-183">{stars}</div>;
  };
  return <section className="mb-10" data-id="element-184">
      <h2 className="text-xl font-bold text-blue-800 mb-6" data-id="element-185">
        Wat cursisten over ons zeggen
      </h2>
      <div className="space-y-8" data-id="element-186">
        {/* Veerle's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-187">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-188">
            <div className="flex items-center" data-id="element-189">
              <div className="w-10 h-10 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold mr-3" data-id="element-190">
                V
              </div>
              <div data-id="element-191">
                <h3 className="font-bold" data-id="element-192">Veerle</h3>
                <div className="text-sm text-gray-500" data-id="element-193">10:33</div>
              </div>
            </div>
          </div>
          <div className="p-4" data-id="element-194">
            <p className="leading-relaxed" data-id="element-195">
              Bedankt voor je lezing, je hebt op een duidelijke manier en met
              concrete voorbeelden veel inzicht bijgebracht! Iets wat ik in de
              toekomst ook graag zou gaan doen. Veel succes nog en ik volg je
              nog op FB.
            </p>
          </div>
        </div>
        {/* Tine's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-196">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-197">
            <div className="flex items-center" data-id="element-198">
              <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-199">
                TI
              </div>
              <div data-id="element-200">
                <div className="flex items-center" data-id="element-201">
                  <h3 className="font-bold mr-2" data-id="element-202">Tine</h3>
                  <span className="text-sm text-gray-500" data-id="element-203">4 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-204">•</span>
                  <span className="text-sm text-gray-500" data-id="element-205">BE</span>
                </div>
                {renderStars(5)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-206">3 sep 2024</div>
          </div>
          <div className="p-4" data-id="element-207">
            <h4 className="font-bold text-lg mb-2" data-id="element-208">
              Niet goed maar uitstekend
            </h4>
            <p className="leading-relaxed mb-3" data-id="element-209">Niet goed maar uitstekend!</p>
            <p className="leading-relaxed" data-id="element-210">
              Amée is een zeer lieve vrouw met een hart voor honden en dat merk
              je zeer goed. De tips helpen echt. Ik raad iedereen met puppy's,
              jongere hondjes en alle andere leeftijden deze cursus aan, vooral
              mensen die problemen hebben met hun troetel. Zowel
              gedragsproblemen als medische problemen. Volg even de gratis
              Masterclass en je bent volledig overtuigd van de cursus en de
              mensen erachter. Heel veel liefs aan iedereen van het team.
              Groetjes Tine Oetzmann
            </p>
          </div>
        </div>
        {/* Nicolette's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-211">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-212">
            <div className="flex items-center" data-id="element-213">
              <div className="w-10 h-10 rounded-full bg-yellow-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-214">
                NI
              </div>
              <div data-id="element-215">
                <div className="flex items-center" data-id="element-216">
                  <h3 className="font-bold mr-2" data-id="element-217">Nicolette</h3>
                  <span className="text-sm text-gray-500" data-id="element-218">2 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-219">•</span>
                  <span className="text-sm text-gray-500" data-id="element-220">NL</span>
                </div>
                <div className="flex items-center" data-id="element-221">
                  {renderStars(5)}
                  <div className="ml-2 flex items-center text-gray-500 text-sm" data-id="element-222">
                    <CheckCircleIcon className="w-4 h-4 mr-1" data-id="element-223" />
                    Geverifieerd
                  </div>
                </div>
              </div>
            </div>
            <div className="text-gray-500" data-id="element-224">8 jul 2024</div>
          </div>
          <div className="p-4" data-id="element-225">
            <h4 className="font-bold text-lg mb-2" data-id="element-226">
              Hele fijne cursus. Aanrader zelfs voor de ervaren honden
              liefhebber.
            </h4>
            <p className="leading-relaxed mb-3" data-id="element-227">
              Nu hebben wij altijd herplaatsers, dus we zijn wel wat gewend.
              Maar bij onze laatste herplaatser hebben we wel hulp nodig.
            </p>
            <p className="leading-relaxed" data-id="element-228">
              In kort tijd nu al zoveel geleerd en handvaten gekregen. Ben enorm
              enthousiast over deze cursus en ik kreeg ook veel hulp aangeboden.
              Het is netjes overzichtelijk, duidelijk maar wat met het meeste
              aanspreekt is dat het zonder commando's gaat maar via
              communiceren.
            </p>
          </div>
        </div>
        {/* Henne's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-229">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-230">
            <div className="flex items-center" data-id="element-231">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-232">
                HB
              </div>
              <div data-id="element-233">
                <div className="flex items-center" data-id="element-234">
                  <h3 className="font-bold mr-2" data-id="element-235">Henne Buskermolen</h3>
                  <span className="text-sm text-gray-500" data-id="element-236">4 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-237">•</span>
                  <span className="text-sm text-gray-500" data-id="element-238">NL</span>
                </div>
                {renderStars(4)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-239">13 aug 2024</div>
          </div>
          <div className="p-4" data-id="element-240">
            <h4 className="font-bold text-lg mb-2" data-id="element-241">
              Ik vond het prettig mijn ervaring op te...
            </h4>
            <p className="leading-relaxed" data-id="element-242">
              Ik vond het prettig mijn ervaring op te halen en voorbereid te
              zijn op de puppy die ik al snel krijg. Goed gewerkt!
            </p>
          </div>
        </div>
        {/* Margreet's Review */}
        <div className="border border-gray-200 rounded-lg overflow-hidden" data-id="element-243">
          <div className="bg-gray-50 p-4 flex items-center justify-between" data-id="element-244">
            <div className="flex items-center" data-id="element-245">
              <div className="w-10 h-10 rounded-full bg-red-100 flex items-center justify-center text-gray-700 font-bold mr-3" data-id="element-246">
                MA
              </div>
              <div data-id="element-247">
                <div className="flex items-center" data-id="element-248">
                  <h3 className="font-bold mr-2" data-id="element-249">Margreet</h3>
                  <span className="text-sm text-gray-500" data-id="element-250">4 reviews</span>
                  <span className="mx-2 text-gray-400" data-id="element-251">•</span>
                  <span className="text-sm text-gray-500" data-id="element-252">NL</span>
                </div>
                {renderStars(5)}
              </div>
            </div>
            <div className="text-gray-500" data-id="element-253">20 apr 2024</div>
          </div>
          <div className="p-4" data-id="element-254">
            <h4 className="font-bold text-lg mb-2" data-id="element-255">
              Dit was de eerste keer dat ik een...
            </h4>
            <p className="leading-relaxed" data-id="element-256">
              Dit was de eerste keer dat ik een online hondencursus volgde en ik
              heb er veel van opgestoken. Hoewel mijn honden zich (meestal)
              prima gedragen, wilde ik vooral leren wat ik zelf nog een beter
              kan doen ivm de communicatie. Dat is gelukt, het valt echt op dat
              omdat ik mij zelf anders opstel, mijn honden nu veel rustiger
              communiceren met andere honden. Vooral met onbekende honden was er
              toch vaak wel flink geblaf. Nu bijna niet meer, heerlijk, wat is
              wandelen toch/weer een genot. Idd: stressless!
            </p>
          </div>
        </div>
      </div>
    </section>;
};